import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import { getTruncationCss } from '../../utils';
import { ensureBuildingSuggestion } from '../../../../utils/types';
import { EInputType } from '../../../../types';
import * as styles from '../../styles.css';
import { ItemContent } from '../ItemContent';
export var BuildingsSuggestionContent = function BuildingsSuggestionContent(props) {
  var item = props.item,
      onLinkClick = props.onLinkClick,
      inputType = props.inputType,
      itemsTruncation = props.itemsTruncation;
  var buildingSuggestion = ensureBuildingSuggestion(item);
  var shouldRenderLink = !(inputType === EInputType.mobile || inputType === EInputType.tablet);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", mergeStyles(styles['building-name'], getTruncationCss(itemsTruncation)), /*#__PURE__*/React.createElement("span", {
    className: getTruncationCss(itemsTruncation, true)
  }, /*#__PURE__*/React.createElement(ItemContent, {
    item: item
  }))), /*#__PURE__*/React.createElement("div", mergeStyles(styles['address'], styles['trunc_1']), buildingSuggestion.address), buildingSuggestion.link && shouldRenderLink &&
  /*#__PURE__*/
  // eslint-disable-next-line react/jsx-no-target-blank
  React.createElement("a", {
    className: styles['link'],
    href: buildingSuggestion.link,
    target: "_blank",
    onClick: onLinkClick
  }, /*#__PURE__*/React.createElement("i", {
    className: styles['link-icon']
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "12",
    viewBox: "0 0 12 12"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2B87DB",
    fillRule: "evenodd",
    d: "M12 .5V5h-1V1H7V0h5v.5zM0 1h1v10H0V1zm1 11v-1h10v1H1zM5 0v1H1V0h4zm7 11h-1V7h1v4zM10 1h1v1h-1V1zM9 2h1v1H9V2zM8 3h1v1H8V3zM7 4h1v1H7V4zM6 5h1v1H6V5z"
  })))));
};